import { createStore } from 'cross-state';
import { useEffect, useEffectEvent, useState } from 'react';

// Use a central timer so that all components using useTimebased will be in sync
const centralTimer = createStore(new Date());

centralTimer.addEffect(() => {
  const id = setInterval(() => {
    centralTimer.set(new Date());
  }, 1000);

  return () => clearInterval(id);
});

export default function useTimebased<T>(valueFn: (date: Date) => T) {
  const value = valueFn(centralTimer.get());
  const [, setState] = useState(value);

  const latestValueFn = useEffectEvent(valueFn);

  useEffect(() => {
    return centralTimer.map(latestValueFn).subscribe((value) => setState(value));
  }, []);

  return value;
}
